import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@store/auth';
import { useMe } from '@features/auth';

/**
 * Auth gerektiren route'lar için sarmalayıcı.
 * - Session yoksa /auth/login'e yönlendirir (oradan geri dönüş için state kaydeder)
 * - Session var ama /auth/me henüz dönmediyse loading state
 */
export function ProtectedRoute() {
  const location = useLocation();
  const session = useAuthStore((s) => s.session);
  const loading = useAuthStore((s) => s.loading);
  const me = useAuthStore((s) => s.me);

  // Tetikle ve cache'le
  const { isLoading: meLoading, isError } = useMe();

  if (loading) {
    return <CenteredLoader label="Bağlantı kontrol ediliyor..." />;
  }

  if (!session) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  if (meLoading && !me) {
    return <CenteredLoader label="Hesap bilgileri yükleniyor..." />;
  }

  if (isError && !me) {
    // /auth/sync henüz yapılmamış olabilir — register flow tamamlanmamış
    return <Navigate to="/auth/register?step=sync" replace />;
  }

  return <Outlet />;
}

function CenteredLoader({ label }: { label: string }) {
  return (
    <div className="flex h-screen items-center justify-center text-muted-foreground">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="mt-4 text-sm">{label}</p>
      </div>
    </div>
  );
}
